import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'dark';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#0DC3DC] focus-visible:ring-offset-2';
  const variantStyles = {
    primary: 'bg-[#0DC3DC] hover:bg-[#0C1B26] text-white shadow-md hover:shadow-lg hover:scale-105',
    secondary: 'bg-[#3AA6F9] hover:bg-[#2A95E8] text-white shadow-md hover:shadow-lg hover:scale-105',
    outline: 'border-2 border-[#0DC3DC] text-[#0DC3DC] hover:bg-[#0DC3DC] hover:text-white',
    dark: 'bg-[#0C1B26] hover:bg-[#0C1B26]/90 text-white shadow-md hover:shadow-lg hover:scale-105'
  };
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthStyles = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${className}`} {...props} data-id="element-1244">
      {children}
    </button>;
}